import {
  LoaderFunctionArgs,
  redirect,
} from "react-router-dom";
import { apiClient, StayTableLoaderResult } from "~/services/apiClient";
import {
  getAuthWrapper,
  loadCookiesData,
  getReadyAuthUser,
  ROUTES,
} from "~/utils";

export async function StayTablePageLoader({
  request,
}: LoaderFunctionArgs): Promise<StayTablePageLoaderType | Response> {
  const auth = getAuthWrapper();
  const user = await getReadyAuthUser();
  if (!user) return redirect("/explore");
  const authAccessInfo = await loadCookiesData(user.uid || "");
  if (!authAccessInfo.success) return redirect("/explore");
  const { ownerID, ownerType } = authAccessInfo.data;

  const result = await apiClient.loader<StayTableLoaderResult>("stay-table", {
    ownerID,
    ownerType,
    userID: user.uid,
  });

  if (!result.success || !result.data) {
    console.error("Failed to load stays:", result.error);
    return redirect(ROUTES.home);
  }

  const filter =
    new URL(request.url).searchParams.get("filter") ?? "all";

  return {
    stays: result.data.stays,
    filter,
  };
}

export type StayTablePageLoaderType = {
  stays: StayTableLoaderResult["stays"];
  filter: string;
};
